export default __webpack_public_path__ + "static/media/icoSupport.82d4fd69.svg";